
const NewsSection = () => {
  const news = [
    {
      id: 1,
      date: '15 декабря 2024',
      image: 'https://public.readdy.ai/ai/img_res/7143905eabc2bc5f7c6e9402fbbe4712.jpg',
      title: 'Открыт новый маршрут на Эльбрус зимой',
      excerpt: 'Специально разработанная программа зимнего восхождения с профессиональными гидами. Уникальная возможность покорить высочайшую вершину России в снежном убранстве.'
    },
    {
      id: 2,
      date: '10 декабря 2024',
      image: 'https://readdy.ai/api/search-image?query=Travel%20industry%20partnership%20handshake%20agreement%20professional%20business%20meeting%20travel%20agency%20office%20background%20modern%20clean%20atmosphere&width=640&height=360&seq=news-2&orientation=landscape',
      title: 'Партнерство с ведущими авиакомпаниями',
      excerpt: 'Заключены новые соглашения с крупнейшими авиаперевозчиками России. Это означает более выгодные цены на билеты и расширенную географию наших туров.'
    },
    {
      id: 3,
      date: '5 декабря 2024',
      image: 'https://readdy.ai/api/search-image?query=Eco-friendly%20sustainable%20tourism%20green%20travel%20initiatives%20nature%20conservation%20forest%20mountains%20clean%20environment%20professional%20photography&width=640&height=360&seq=news-3&orientation=landscape',
      title: 'Запуск программы экотуризма',
      excerpt: 'Новая линейка экологических туров с минимальным воздействием на природу. Мы поддерживаем ответственный туризм и заботимся о сохранении уникальных природных территорий.'
    }
  ];

  return (
    <section className="bg-gray-50 py-16 md:py-20 lg:py-24" aria-labelledby="news-heading">
      <div className="max-w-[1360px] mx-auto px-6">
        <div className="flex items-center justify-between mb-12">
          <h2 id="news-heading" className="font-mulish font-bold text-3xl lg:text-4xl text-gray-900">
            Новости
          </h2>
          <a
            href="/news"
            className="hidden md:inline-block font-open-sans text-[#1E88E5] hover:text-[#0D47A1] font-semibold transition-colors duration-300 cursor-pointer"
          >
            Все новости
          </a>
        </div>

        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {news.map((item) => (
            <li key={item.id}>
              <article className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 h-full group">
                <a href="/news" className="block h-full cursor-pointer">
                  <div className="aspect-[16/9] overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-6">
                    <time 
                      className="font-open-sans text-sm text-gray-500 block mb-3"
                      dateTime={item.date}
                    >
                      {item.date}
                    </time>
                    <h3 className="font-mulish font-bold text-xl text-gray-900 mb-4 group-hover:text-[#1E88E5] transition-colors duration-300 line-clamp-2">
                      {item.title}
                    </h3>
                    <p className="font-open-sans text-sm text-gray-600 leading-relaxed line-clamp-3">
                      {item.excerpt}
                    </p>
                  </div>
                </a>
              </article>
            </li>
          ))}
        </ul>

        {/* Кнопка для мобильной версии */}
        <div className="text-center mt-8 md:hidden">
          <a
            href="/news"
            className="inline-block font-open-sans text-[#1E88E5] hover:text-[#0D47A1] font-semibold transition-colors duration-300 cursor-pointer"
          >
            Все новости
          </a>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
